import { render, staticRenderFns } from "./scalingExpertInfo.vue?vue&type=template&id=47b8e6dd"
import script from "./scalingExpertInfo.vue?vue&type=script&lang=js"
export * from "./scalingExpertInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports